import type { ReactNode } from 'react';

export const symbol_fit_page_height: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18H220Zm520-60v-680H220v680h520Zm0-680H220h520ZM420-624h120q9.92 0 13.46-9.5Q557-643 550-650l-49-49q-9-9-21-9t-21 9l-49 49q-7 7-3.46 16.5T420-624Zm81 363 49-49q7-7 3.46-16.5T540-336H420q-9.92 0-13.46 9.5Q403-317 410-310l49 49q9 9 21 9t21-9Z"
		/>
	</svg>
);
